<template>
  <v-list
    class="transparent mt-6 py-0"
  >
    <template v-for="(item, index) in lista">
      <ListaItem
        v-if="item.link"
        :key="`item-lista${index}`"
        :item="item"
      />
      <v-divider
        v-if="item.link"
        :key="`item-divider-${index}`"
      />
      <v-subheader
        v-if="!item.link"
        :key="`item-titulo-${index}`"
        :class="$vuetify.breakpoint.lgAndUp ? 'body-2' : ''"
        class="primary--text pa-0 mt-6 subheaderHeight"
      >
        {{ item.label }}
      </v-subheader>
    </template>
  </v-list>
</template>

<script>
import ListaItem from '@/components/Lista/ListaItem.vue';

export default {
  name: 'ListaContainer',

  components: {
    ListaItem,
  },

  props: {
    lista: {
      type: Array,
      required: true,
    },
  },
};
</script>
